<template>
  <div class="payment-item" @click="onPayMode(item)">
    <div class="payment-item-info">
      <img
        v-if="item.pay_icon"
        :src="item.pay_icon"
        class="payment-item-icon"
      />
      <div class="payment-content">
        <div class="payment-content-title">
          {{ item.pCardnumber || item.label }}
        </div>
        <!-- <p class="payment-content-des"></p> -->
      </div>
    </div>
    <div class="payment-item-checked">
      <img
        class="payment-item-checked-icon"
        :src="
          payMode.pId === item.pId && item.currencyName === payMode.currencyName
            ? require('@/assets/imgs/checkbox_selected.png')
            : require('@/assets/imgs/checkbox.png')
        "
        alt=""
      />
    </div>
  </div>
</template>

<script >
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    payMode: {
      type: Object,
      default: () => {}
    }
  },
  created() {},
  data() {
    return {}
  },
  methods: {
    // 支付方式切换
    onPayMode(item) {
      this.$emit("onPayMode", { ...item })
    }
  }
}
</script>

<style lang="less" scoped>
.payment-item {
  position: relative;
  display: flex;
  padding: 30px 20px;
  border-bottom: 1px solid #dddddd;
  &-info {
    display: flex;
  }
  &-icon {
    width: 40px;
    margin-right: 12px;
    object-fit: contain;
  }
  &-checked {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    &-icon {
      width: 40px;
      object-fit: contain;
    }
  }
}
</style>
